export const getContactUsData = state => state.contactUs.contactUsData;
export const getSendResponse = state => state.contactUs.contactUsSendResponse;
export const getError = state => state.contactUs.error;
export const getStatus = state => state.contactUs.status;